import React, { useState, useEffect } from "react";

// import CardMap from '../../components/CardMap';
import Lottie from "react-lottie";
import animationLocalizacao from "../animations/localizacao.json";
import CalcCoordination from "./calcCoordinates";
import "./style.css";

export default function GearDashboard({ dados, onGps }) {
  const [distancia_do_local, setdistancia_do_local] = useState(undefined);

  useEffect(() => {
    getLocation();

    const time = setInterval(() => {
      getLocation();
    }, 5000);

    return () => clearInterval(time);
  }, []);

  function getLocation() {
    const navigatorLocationOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const dst = calcLocation(
          position.coords.latitude,
          position.coords.longitude,
          dados.lat,
          dados.lng
        );
        setdistancia_do_local(dst);
        if (dst < dados.distance_gps) {
          onGps &&
            onGps({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
        }
      },
      (erro) => {
        //  alert(erro)
      },
      navigatorLocationOptions
    );

    // navigator.permissions.query({name:'geolocation'})
    //   .then((result) => {
    //     if (result.state === 'granted') {
    //       navigator.geolocation.getCurrentPosition(pos => {
    //          alert('Retrieved user location', pos);

    //       }, (error) => {
    //         alert('System/OS services disabled', error);

    //       }, navigatorLocationOptions);

    //     } else {
    //       alert(`Browser location services disabled ${result.state}`);

    //     }
    //   }, (error) => {
    //     alert('Browser permissions services unavailable', error);
    //   }
    // );
  }

  const calcLocation = (latitude, longitude, latCond, lngCond) => {
    const pontoAtual = {
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
    };

    const destinoAtual = {
      latitude: parseFloat(latCond),
      longitude: parseFloat(lngCond),
    };

    const distancia = parseInt(
      CalcCoordination(pontoAtual, destinoAtual) * 1000
    );
    return distancia;
  };

  function varificaStringDistancia() {
    if (distancia_do_local) {
      if (distancia_do_local > 1000) {
        const km = (distancia_do_local / 1000).toFixed(1);
        return `${km} km`;
      } else {
        return `${distancia_do_local} m`;
      }
    }
    return "";
  }

  return (
    <div className="loadingGps">
      <div className="gps-card">
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: animationLocalizacao,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={undefined}
          width={undefined}
          style={{ margin: 0 }}
          className="gps-animation"
        />
        {distancia_do_local ? (
          <>
            <p className="gps-title">Aproxime-se do local do convite</p>
            <p className="gps-subtitle">Distância atual:</p>
            <div className="gps-distance-badge">
              {varificaStringDistancia()}
            </div>
          </>
        ) : (
          <>
            <p className="gps-title">Verificando localização…</p>
            <p className="gps-subtitle">Aguarde um instante</p>
          </>
        )}
      </div>
    </div>
  );
}
